
import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'
import IconGoogle from '~/components/icons/IconGoogle.vue'
import { namespace as baseInfoStore, GetterType as BaseInfoGetterType, BaseInfoState } from '~/store/modules/BaseInfo'

const BaseInfoStore = namespace(baseInfoStore)

@Component({
  components: {
    IconGoogle,
  },
})
export default class GoogleRating extends Vue {
  @BaseInfoStore.Getter(BaseInfoGetterType.GOOGLE_RATING)
  googleRating!: BaseInfoState['google_rating']

  @Prop({
    default: '',
    type: String,
  })
  borderColor!: string

  get wrapperStyles () {
    return Object.assign({},
      this.borderColor && {
        border: `1px solid ${this.borderColor}`,
      })
  }

  get rating (): number {
    return this.googleRating?.rating ?? 0
  }

  get reviews (): number {
    return this.googleRating?.reviews ?? 0
  }

  get ratingRounded (): number {
    return Math.ceil(this.rating)
  }
}
